var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',_vm._b({attrs:{"value":_vm.unformatted,"formatter":_vm.formatter,"lazy-formatter":_vm.lazy,"required":_vm.required},on:{"keydown":_vm.onKeyDown,"blur":_vm.blur,"input":_vm.input}},'b-form-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }